import { Button, IconButton } from '@mui/material';
import { ReactNode } from 'react';
import { DynamicIcon, Tooltip } from 'src/components';
import { useCopyToClipboard } from 'src/utils/hooks';

interface CopyToClipboardButtonProps {
  content: string;
  onClick?: () => void;
  successMessage?: string;
  tooltipText?: string;
  children?: ReactNode;
  size?: 'large' | 'medium' | 'small';
}

export const CopyToClipboardButton = ({
  content,
  onClick,
  successMessage,
  tooltipText = 'Copy to clipboard',
  children,
  size = 'small',
}: CopyToClipboardButtonProps) => {
  const { copyToClipboard } = useCopyToClipboard({ successMessage });

  const handleClick = async () => {
    await copyToClipboard(content);
    onClick?.();
  };

  return (
    <Tooltip title={tooltipText}>
      {children ? (
        <Button
          variant="text"
          size={size}
          onClick={handleClick}
          sx={{
            whiteSpace: 'nowrap',
            background: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
            color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
          }}
        >
          {children}
        </Button>
      ) : (
        <IconButton sx={{ padding: 0 }} aria-label="copy" onClick={handleClick}>
          <DynamicIcon name="content_copy" />
        </IconButton>
      )}
    </Tooltip>
  );
};
